<template>
  <WdsTag v-if="label" sm variant="secondary">
    {{ label }}
  </WdsTag>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsTag } from '@worksome/wds-components'
import { graphql, FragmentType, useFragment } from '@/gql'
import { LocationPreference } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const frag = graphql(`
  fragment JobLocationPreferenceColumn on Job {
    id
    locationPreference
  }
`)

const props = defineProps<{
  row: FragmentType<typeof frag>
}>()

const column = computed(() => {
  if (!props.row) return null

  return useFragment(frag, props.row)
})

const label = computed(() => {
  switch (column.value?.locationPreference) {
    case LocationPreference.OnsiteOnly:
      return $t('On-site')
    case LocationPreference.OnsiteSome:
      return $t('Hybrid')
    case LocationPreference.RemoteOnly:
      return $t('Remote')
    default:
      return null
  }
})
</script>
